import { Accordion, AccordionItem, LabelValue } from '../../utils';
import { AlertEnum, ButtonVariantEnum } from '../../enums';
import { CandidaturaForm, CandidaturasGerenciamentoCardList } from '../candidatura';
import { CargoResponseType, CargosCandidaturasGerenciamentoListType } from '../../types';
import { DefaultCard, IconButton } from '../../components';
import { FaPen, FaTrashAlt, FaUserTie } from 'react-icons/fa';
import { useAlert, useAuthAxios, useErrorHandler, useForceReRender, useModal } from '../../hooks';

import { ApiHelper } from '../../helpers';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

const CargosCandidaturasGerenciamentoList: FunctionComponent<CargosCandidaturasGerenciamentoListType> = ({
  idEleicao,
  cargos,
  setCargos,
  setCargoAlteracao,
  formRef,
}) => {
  const { t } = useTranslation();
  const axios = useAuthAxios();
  const { createAlert } = useAlert();
  const errorHandler = useErrorHandler();
  const { forceReRender } = useForceReRender();
  const { confirmModal } = useModal();

  return (
    <DefaultCard
      cardTitle={t('label.cargos_candidaturas')}
      empty={cargos?.length <= 0}
      emptyIcon={FaUserTie}
      emptyMessage={t('texto.nenhum_cargo_cadastrado')}
    >
      <Accordion id="accordionCargosCandidaturas">
        {cargos.map((cargo: CargoResponseType) => (
          <AccordionItem
            key={cargo.id}
            header={
              <div className="d-flex w-100 justify-content-between">
                <div>{cargo.nome}</div>
                <LabelValue
                  label={t(`label.candidatura${cargo.candidaturas?.length !== 1 ? 's' : ''}`)}
                  value={Array.isArray(cargo.candidaturas) ? cargo.candidaturas.length : '0'}
                  boldValue
                  valueFirst
                />
              </div>
            }
            headerAction={
              <div className="m-1 d-flex flex-row gap-2">
                <IconButton
                  Icon={FaPen}
                  title={t('label.alterar_cargo')}
                  variant={ButtonVariantEnum.PRIMARY}
                  onClick={() => {
                    setCargoAlteracao(cargo);
                    if (formRef.current !== null) {
                      formRef.current.scrollIntoView();
                    }
                  }}
                />
                <IconButton
                  Icon={FaTrashAlt}
                  title={t('label.remover_cargo')}
                  variant={ButtonVariantEnum.DANGER}
                  onClick={() => {
                    confirmModal(
                      t('confirmacao.remover_cargo'),
                      () => {
                        axios
                          .delete(ApiHelper.getUrl.apiSCE.cargo(idEleicao, cargo.id))
                          .then(() => {
                            setCargos(cargos.filter((c: CargoResponseType) => c.id !== cargo.id));
                            createAlert(t('sucesso.remover_cargo'), AlertEnum.SUCCESS);
                            forceReRender();
                          })
                          .catch((error) => errorHandler(error, t('erro.remover_cargo')));
                      },
                      ButtonVariantEnum.DANGER,
                      t('label.remover_cargo'),
                    );
                  }}
                />
              </div>
            }
            footer={<CandidaturaForm idEleicao={idEleicao} idCargo={cargo.id} key={cargo.id} />}
          >
            <>
              <CandidaturasGerenciamentoCardList idEleicao={idEleicao} idCargo={cargo.id} candidaturas={cargo.candidaturas!} />
            </>
          </AccordionItem>
        ))}
      </Accordion>
    </DefaultCard>
  );
};

export default CargosCandidaturasGerenciamentoList;
